@if (errorMessage) {
<p-message
  severity="error"
  variant="simple"
  size="small"
  class="validation-error-message"
  >{{ errorMessage }}</p-message
>
}
